/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import '@stimulus/polyfills'
import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import Turbolinks from "turbolinks";



const application = Application.start();
const context = require.context("../controllers", true, /\.js$/);
application.load(definitionsFromContext(context));

Turbolinks.start();

window.fbAsyncInit = function() {
    FB.init({
        appId            : '146873318797099',
        autoLogAppEvents : true,
        xfbml            : true,
        version          : 'v3.0'
    });
};



(function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

const htmlElement = document.querySelector('html');
htmlElement.classList.add('clicking');
document.addEventListener('click', function(){
    htmlElement.classList.add('clicking');
});

document.addEventListener('keyup', function(e){
    if (e.keyCode === 9) {
        htmlElement.classList.remove('clicking');
    }
});
